import styled from 'styled-components';

export const SFields = styled.div`
  position: relative;
  margin-bottom: 42px;
`;

export const SSubmitError = styled.div`
  min-height: 30px;
  text-align: center;
  font-size: 1.1em;
  color: red;
  margin-bottom: 6px;
`; 